/**
 * Shows the content if the locale is english and hides it otherwise.
 *
 */
import {RequestInfo} from "@khan/shared-core";

interface Props {
    children: React.ReactNode;
    // If true, will always show, regardless of the usual conditions.
    alwaysShow?: boolean;
}

export function CleverLibraryActiveWrapper(props: Props): React.ReactNode {
    const {children, alwaysShow} = props;
    const isEN = RequestInfo.kaLocale === "en";

    if (isEN || alwaysShow) {
        return children;
    }

    return null;
}
